import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Performance monitoring
import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
function sendToAnalytics(metric) {
  if (process.env.REACT_APP_DEBUG === 'true') {
    console.log('📊 Performance Metric:', metric);
  }
  // In production, send to analytics service
}

getCLS(sendToAnalytics);
getFID(sendToAnalytics);
getFCP(sendToAnalytics);
getLCP(sendToAnalytics);
getTTFB(sendToAnalytics);

// Service Worker Registration & Cache Purge
if ('serviceWorker' in navigator) {
  // Purge old cache storage if present
  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        if (name.includes('helpbook')) {
          caches.delete(name);
        }
      });
    });
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        registration.update();
        console.log('✅ SW registered & updated: ', registration);
      })
      .catch((registrationError) => {
        console.log('❌ SW registration failed: ', registrationError);
      });
  });
}
